import { useEffect, useState } from "react";
import { getProductList } from "../services/products";

export const useProductOptions = () => {
    const [productOptions, setProductOptions] = useState([]);
    const getProductOptions = async () => {
      try {
        const { results } = await getProductList();
        const productWithPrices = results.filter((product) => product.prices);
        setProductOptions(
          productWithPrices.map((item) => ({
            value: item.id,
            label: item.code + "-" + item.name,
            ...item
          }))
        );
      } catch (error) {
        console.log("error", error);
      }
    };

    useEffect(() => {
      getProductOptions();
    }, []);

    return { productOptions };
}